import { Component, Inject, OnInit } from '@angular/core';
import { Router, NavigationEnd, Event as NavigationEvent } from '@angular/router';

@Component({
  selector: 'app-biz-layout',
  templateUrl: './biz-layout.component.html',
  styleUrl: './biz-layout.component.scss'
})
export class BizLayoutComponent implements OnInit {
  url: any;
  private scrollPosition: [number, number] = [0, 0];

  constructor( private router: Router,  @Inject("WINDOW") private window: any) { }

  ngOnInit(): void {
    this.url = this.router.url;
    this.router.events.subscribe((event: NavigationEvent) => {
      if (event instanceof NavigationEnd) {
        this.url = event.urlAfterRedirects
        this.window.scrollTo(this.scrollPosition[0], this.scrollPosition[1]);
      }
    });
  }
  onNavigate(url) {
    this.scrollPosition = [this.window.scrollX, this.window.scrollY];
  }
}
